import Image from '@components/Image/Image';
import './InstructionBubble.scss';

interface InstructionBubbleProps {
  children: JSX.Element;
  movingpic: string;
}

function InstructionBubble({ movingpic, children }: InstructionBubbleProps) {
  return (
    <div className="instruction-bubble w-100 flex">
      <div className="alp-logo-wrap box-center">
        <Image src={movingpic} alt="A Learning Place Logo" />
      </div>
      <div className="speech-bubble-col">
        <div className="bubble-box">{children}</div>
      </div>
    </div>
  );
}

export default InstructionBubble;
